module.exports = __webpack_public_path__ + "static/media/stem-robotics-lab-icon_2-color.db2ac3bd.svg";